export interface ILazyLoadState {
    imageHasLoaded: { [key: string]: boolean };
}

export const defaultLazyLoadState: ILazyLoadState = {
    imageHasLoaded: {}
};